import React, { useState } from "react";
import { fontStyles } from "../../../../shared/services/themes";

const FontStyleSelector = ({ fontStyle, setFontStyle }: { fontStyle: string; setFontStyle: (val: string) => void }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full flex flex-col items-center relative">
      <label className="text-lg font-medium mb-2 text-center">Select Font Style</label>
      <div className="w-full p-2 border rounded-lg cursor-pointer bg-white" onClick={() => setOpen((prev) => !prev)}>
        <span className={`${fontStyles[fontStyle]} text-center block`}>{fontStyle}</span>
      </div>
      {open && (
        <div className="absolute z-50 w-full max-h-60 overflow-y-auto border border-gray-300 mt-1 bg-white rounded-lg shadow-lg">
          {Object.keys(fontStyles).map((style) => (
            <div
              key={style}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${fontStyles[style]}`}
              onClick={() => {
                setFontStyle(style);
                setOpen(false);
              }}
            >
              {style}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FontStyleSelector;
